import React from "react";
import {usePage} from "../../Context/PageContext"
import { useQuery } from "react-query";
import fetchPageById from "../../Data/page_service";
export const CGUDisconnected = () => {
  const {page , setPageAttributes}=usePage()
  useQuery('pageById', () => fetchPageById(setPageAttributes , 'cgu'));

  return (
    <div className="cg" style ={{height:'90vh', marginTop:'0.5rem', overflow:'auto'}}>
      {page && <div dangerouslySetInnerHTML={{ __html:  page.contenu}} />}
    </div>
  );
};
